import { render, staticRenderFns } from "./Lgx239834441344614400.vue?vue&type=template&id=6c6306e4&scoped=true&"
import script from "./Lgx239834441344614400.vue?vue&type=script&lang=js&"
export * from "./Lgx239834441344614400.vue?vue&type=script&lang=js&"
import style0 from "./Lgx239834441344614400.vue?vue&type=style&index=0&id=6c6306e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6306e4",
  null
  
)

export default component.exports